import { Controller } from "@hotwired/stimulus"

// Accordion controller for FAQ sections
export default class extends Controller {
  static targets = ["item", "button", "content", "icon"]

  toggle(event) {
    const button = event.currentTarget
    const item = button.closest("[data-accordion-target='item']")
    const content = item.querySelector("[data-accordion-target='content']")
    const icon = item.querySelector("[data-accordion-target='icon']")

    const isExpanded = button.getAttribute("aria-expanded") === "true"

    // Close all other items first
    this.itemTargets.forEach((otherItem) => {
      if (otherItem !== item) {
        const otherButton = otherItem.querySelector("[data-accordion-target='button']")
        const otherContent = otherItem.querySelector("[data-accordion-target='content']")
        const otherIcon = otherItem.querySelector("[data-accordion-target='icon']")

        if (otherButton && otherContent) {
          otherButton.setAttribute("aria-expanded", "false")
          otherContent.classList.add("hidden")
          if (otherIcon) {
            otherIcon.classList.remove("rotate-180")
          }
        }
      }
    })

    // Toggle current item
    if (isExpanded) {
      button.setAttribute("aria-expanded", "false")
      content.classList.add("hidden")
      if (icon) {
        icon.classList.remove("rotate-180")
      }
    } else {
      button.setAttribute("aria-expanded", "true")
      content.classList.remove("hidden")
      if (icon) {
        icon.classList.add("rotate-180")
      }
    }
  }
}
